export default {
  loadingText: {
    id: 'bo_seller.listing.product_create.step_1.loading_text',
    defaultMessage: 'We are fetching the product categories...',
  },
  otherCategoriesText: {
    id: 'bo_seller.listing.product_create.step_1.other_categories_text',
    defaultMessage:
      'Not seeing your category above? Select it from the dropdown below.',
  },
  categorySelectLabel: {
    id: 'bo_seller.listing.product_create.step_1.category_select_label',
    defaultMessage: 'Select product category',
  },
  submitButton: {
    id: 'bo_seller.listing.product_create.step_1.submit_button',
    defaultMessage: 'Next',
  },
  resetButton: {
    id: 'bo_seller.listing.product_create.step_1.reset_button',
    defaultMessage: 'Reset',
  },
  mainCategoriesText: {
    id: 'bo_seller.listing.product_create.step_1.main_categories_text',
    defaultMessage:
      'Select the category for the product you want to add to the catalog.',
  },
  noOptionsMessage: {
    id: 'bo_seller.listing.product_create.step_1.no_options_message',
    defaultMessage: 'No corresponding category found',
  },
}
